import { useEffect, useState } from 'react';

import { getExternalApplicationFlag } from '@/helpers/external-apply-flow-flag';

export function useIsExternalApplicationFlowEnabled(isPaidJob: boolean): {
  isExternalApplicationFlowEnabled: boolean;
  externalApplicationFlowTrackingProps: {
    PropContextAddition?: string;
  };
} {
  const [isRegisterFlowCompleted, setIsRegisterFlowCompleted] = useState(false);

  const isExternalApplicationFlowEnabled = !isPaidJob && !isRegisterFlowCompleted;

  const PropContextAddition = isExternalApplicationFlowEnabled
    ? 'jobs_registration_modal_show'
    : isPaidJob
    ? 'jobs_registration_modal_skip_paid'
    : 'jobs_registration_modal_skip_reg_ok';

  const externalApplicationFlowTrackingProps = { PropContextAddition };

  useEffect(() => {
    // the flag is stored on browser side so we update it after render
    setIsRegisterFlowCompleted(getExternalApplicationFlag().completed);
  }, []);

  return { isExternalApplicationFlowEnabled, externalApplicationFlowTrackingProps };
}
